/* © Facilogi. See LICENSE file for full copyright & licensing details. */

import { $t } from "App/IOC";
import { Column, CustomError } from "App/Models";
// import { Dictionary } from "App/Contracts";
import Columns from "App/UseCases/Columns";
// import Fields from "Shared/UseCases/Choices/Fields";

let sort: Column;
let columns: Column[] = [];

function GetDefaultSort(): Column {
    /* To avoid an issue with $t being empty because it has yet to be injected to Ioc because if
       we put this instantiation at the module level here, it will get executed during
       node module importation step, which is before we inject the actual $t() implementation into
       our Ioc (Through Web/Main.ts), so we wrap it in a funtion. */
    if( sort === undefined )
        sort = new Column( "Sequence", $t( "Prices_columnSequence" ) );

    return sort;
}

function getDefault(): Column[] {
    if( columns.length === 0 )
        columns = [
            GetDefaultSort(),
            new Column( "Amount", $t( "Prices_columnAmount" ) ),
            new Column( "Currency", $t( "Prices_columnCurrency" ) ),
            new Column( "Description", $t( "Prices_columnDescription" ) ),
            new Column( "Model", $t( "Prices_columnModel" ) )
        ];

    return columns;
}

async function Get(): Promise<[ Column[], CustomError | undefined ]> {
    return await Columns.Get( "Prices", getDefault() );
}

// function GetMapping(): Dictionary<string> {
//     return { ...Fields.GetMapping() };
// }

async function Toggle( existingColumn: Column ): Promise<CustomError | undefined> {
    return await Columns.Toggle( "Prices", existingColumn, getDefault() );
}

export default {
    GetDefaultSort,
    Get,
    // GetMapping,
    Toggle
};
